import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-index" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "main p20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_shortMessageLogin = _resolveComponent("shortMessageLogin")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_passwordLogin = _resolveComponent("passwordLogin")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "l-img" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.activeName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
          class: "e-tabs",
          onTabClick: _ctx.handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "短信登录",
              name: "shortMessage"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_shortMessageLogin)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "密码登录",
              name: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_passwordLogin)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onTabClick"]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "注册即领7天免费卡", -1))
      ])
    ])
  ]))
}